"use client";

import { cn } from "@/lib/utils";
import { useRef } from "react";
import DisplayCards from "./display-cards";
import { Building2, PenTool, TrendingUp } from "lucide-react";
const stageCards = [{
  icon: <Building2 className="size-4" />,
  title: "Foundation",
  description: "Brand identity & domain setup",
  date: "Stage 1",
  iconClassName: "bg-black/10 dark:bg-white/10",
  className: "[grid-area:stack] hover:-translate-y-12"
}, {
  icon: <PenTool className="size-4" />,
  title: "Content",
  description: "Launch copy that converts",
  date: "Stage 2",
  iconClassName: "bg-black/10 dark:bg-white/10",
  className: "[grid-area:stack] translate-x-12 translate-y-10 hover:-translate-y-2"
}, {
  icon: <TrendingUp className="size-4" />,
  title: "Launch",
  description: "Growth systems & viral reach",
  date: "Stage 3",
  iconClassName: "bg-black/10 dark:bg-white/10",
  className: "[grid-area:stack] translate-x-24 translate-y-20 hover:translate-y-10"
}];
export const MissionStatement = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const ref = useRef<HTMLDivElement>(null);
  return <div ref={ref} className={cn("flex flex-col gap-8 py-20 ", className)} {...props} data-sentry-component="MissionStatement" data-sentry-source-file="mission-statement.tsx">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 lg:px-8">
        {/* Main heading */}
        {/* <div>
          <h2 className="mb-2 text-4xl font-medium text-foreground">Why Us?</h2>
         </div> */}

        {/* Two column layout */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4 lg:gap-12">
          {/* Left column - Value propositions */}
          <div className="space-y-4 lg:col-span-3 lg:pr-10">
            <div className="text-lg font-semibold text-foreground/90 sm:text-xl">
              Tell me if this is you:
            </div>
            <div className="text-lg text-foreground/90 sm:text-xl">
              You built something amazing. You KNOW it could help thousands
            </div>
            <div className="text-lg text-foreground/90 sm:text-xl">
              You&apos;re super excited. You launch and... crickets.
            </div>
            <div className="text-lg text-foreground/90 sm:text-xl">
              Here&apos;s the ugly truth:{" "}
              <span className="font-semibold">
                90% of startups fail not because their product sucks, but
                because nobody knows it exists.
              </span>
            </div>
            <div className="text-lg text-foreground/90 sm:text-xl">
              You know you need to &quot;get the word out there&quot; but you
              don&apos;t even know where to start!
            </div>

            <div className="ml-4 text-lg text-foreground/90 sm:text-xl">
              • What do I write?
            </div>
            <div className="ml-4 text-lg text-foreground/90 sm:text-xl">
              • Where do I post?
            </div>
            <div className="ml-4 text-lg text-foreground/90 sm:text-xl">
              • What platforms actually work?
            </div>

            <div className="text-lg text-foreground/90 sm:text-xl">
              <span className="font-semibold">Viral Launch fixes that.</span>
            </div>

            <div className="text-lg text-foreground/90 sm:text-xl">
              I reverse-engineered what worked for successful startups across X,
              ProductHunt, Reddit, MicroLaunch, and early communities — and
              built a <span className="font-semibold">3-stage playbook</span>{" "}
              into the software.
            </div>

            <div className="text-lg text-foreground/90 sm:text-xl">
              ViralLaunch helps you{" "}
              <span className="font-semibold">create launch content</span> that
              converts,{" "}
              <span className="font-semibold">run viral giveaways</span> that
              turn one customer into ten, and{" "}
              <span className="font-semibold">launch on 100+ platforms</span>{" "}
              where successful startups get their first customers.
            </div>

            <div className="text-lg text-foreground/90 sm:text-xl">
              Go from idea to{" "}
              <span className="font-semibold">100 customers in days</span>.
            </div>
          </div>

          {/* Right column - Display Cards */}
          <div className="flex justify-center lg:col-span-1 lg:justify-start">
            <div className="mt-8 flex min-h-[200px] w-full items-center justify-center sm:-mt-14 sm:min-h-[300px] lg:-mt-30 lg:min-h-[10px]">
              <DisplayCards cards={stageCards} data-sentry-element="DisplayCards" data-sentry-source-file="mission-statement.tsx" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};